// Editorun kendi (master: tum) uretim gecmisi.
// F2: filtre + pagination + sil (ENABLE_DELETE flag ile hazir iskelet mevcut).

import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { supabase, type AudioHistoryRow } from '../lib/supabase';
import { useAuth } from '../lib/auth-context';

// F2 feature flag — silme ozelligi hazir degilse gizli kalir.
const ENABLE_DELETE = import.meta.env.VITE_ENABLE_DELETE === 'true';

export default function MyHistory() {
  const auth = useAuth();
  const [showAll, setShowAll] = useState(false);
  const [rows, setRows] = useState<AudioHistoryRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    let query = supabase
      .from('audio_history')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(100);

    if (!showAll || !auth.isMaster) {
      query = query.eq('actor_email', auth.email!.toLowerCase());
    }

    void query.then(({ data }) => {
      setRows((data ?? []) as AudioHistoryRow[]);
      setLoading(false);
    });
  }, [showAll, auth.isMaster, auth.email]);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-5xl">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Gecmis</h1>
          <p className="text-slate-500 text-sm">Son 100 kayit.</p>
        </div>
        {auth.isMaster && (
          <label className="text-sm flex items-center gap-2 text-slate-600 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={showAll}
              onChange={(e) => setShowAll(e.target.checked)}
              className="rounded"
            />
            Tum kullanicilar
          </label>
        )}
      </div>

      {loading ? (
        <p className="text-slate-400">Yukleniyor…</p>
      ) : rows.length === 0 ? (
        <p className="text-slate-400">Kayit yok.</p>
      ) : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead className="bg-slate-50 text-slate-600 text-xs uppercase">
              <tr>
                <th className="px-4 py-3 text-left">Tarih</th>
                {showAll && <th className="px-4 py-3 text-left">Kullanici</th>}
                <th className="px-4 py-3 text-left">Ses</th>
                <th className="px-4 py-3 text-left">Metin (ilk 80)</th>
                <th className="px-4 py-3 text-right">Char</th>
                <th className="px-4 py-3 text-right">$</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                    {new Date(r.created_at).toLocaleString('tr-TR')}
                  </td>
                  {showAll && (
                    <td className="px-4 py-3 text-slate-600 text-xs">{r.actor_email}</td>
                  )}
                  <td className="px-4 py-3 text-slate-700 font-mono text-xs">{r.voice_slug}</td>
                  <td className="px-4 py-3 text-slate-700 max-w-xs truncate">
                    {r.text_full.slice(0, 80)}{r.text_full.length > 80 && '…'}
                  </td>
                  <td className="px-4 py-3 text-right text-slate-500 font-mono">{r.text_chars}</td>
                  <td className="px-4 py-3 text-right text-slate-500 font-mono">
                    {r.estimated_cost_usd !== null ? `$${Number(r.estimated_cost_usd).toFixed(3)}` : '—'}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <div className="inline-flex items-center gap-2">
                      <a
                        href={r.public_url}
                        download
                        className="inline-flex items-center gap-1 text-[color:var(--color-primary)] hover:underline text-sm"
                      >
                        <Download size={14} /> Indir
                      </a>
                      {/* F2 silme iskelet — ENABLE_DELETE=true olmadan gizli */}
                      {ENABLE_DELETE && (
                        <button
                          onClick={() => alert('F2')}
                          className="text-xs text-red-500 hover:underline"
                        >
                          Sil
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
